"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_1 = __importDefault(require("ducks/app"));
const contact_infos_1 = __importDefault(require("ducks/contact-infos"));
const divisions_1 = __importDefault(require("ducks/divisions"));
const households_1 = __importDefault(require("ducks/households"));
const members_1 = __importDefault(require("ducks/members"));
const orders_1 = __importDefault(require("ducks/orders"));
const profile_1 = __importDefault(require("ducks/profile"));
const teams_1 = __importDefault(require("ducks/teams"));
const user_1 = __importDefault(require("ducks/user"));
const redux_1 = require("redux");
const redux_form_1 = require("redux-form");
exports.default = (0, redux_1.combineReducers)({
    app: app_1.default,
    user: user_1.default,
    members: members_1.default,
    teams: teams_1.default,
    divisions: divisions_1.default,
    orders: orders_1.default,
    profile: profile_1.default,
    contactInfos: contact_infos_1.default,
    households: households_1.default,
    form: redux_form_1.reducer,
});
